// i18n area 'cluster' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.ru-RU.meta.json.
import type { enUS } from './cluster'

export const ruRU: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Гарантийные доступы',
      subtitle: 'Сервисная дверь узла: доступ только для чтения с временным паролем и аварийная учётная запись с паролем из сейфа',
      readOnlyTitle: 'Доступ только для чтения (trantor)',
      stateNone: 'закрыт',
      stateGranted: 'открыт',
      stateGrantedPending: 'предоставлен — применяется на узле',
      grantedBy: 'Предоставил',
      grantedAt: 'Предоставлен',
      expiresAt: 'Истекает',
      reason: 'Причина',
      endedAt: 'Закрыт',
      endedReason: {
        revoked: 'отозван',
        expired: 'истёк (TTL)',
        reboot: 'перезагрузка узла',
        failed: 'не применён (задача не удалась)'
      },
      grant: 'Предоставить доступ только для чтения…',
      grantTitle: 'Предоставить доступ только для чтения',
      grantSubmit: 'Предоставить',
      grantError: 'Предоставление отклонено',
      grantConfirm: 'TVirt генерирует временный пароль для системного пользователя «trantor» (только чтение: journal и диагностика, без sudo) и устанавливает его на узле задачей. Пароль показывается ТОЛЬКО один раз, при подтверждении; он перестаёт действовать по истечении срока, при отзыве или при следующей перезагрузке узла.',
      reasonLabel: 'Причина',
      reasonHint: 'Почему вы открываете дверь: это остаётся в предоставлении, в аудите и в журнале',
      ttlLabel: 'Длительность',
      ttlHours: '{n} ч',
      revoke: 'Отозвать доступ только для чтения…',
      revokeTitle: 'Отозвать доступ только для чтения',
      revokeSubmit: 'Отозвать',
      revokeError: 'Отзыв отклонён',
      revokeConfirm: 'Предоставление прекращается немедленно, и задача снова блокирует пользователя «trantor» на узле: временный пароль перестаёт действовать.',
      passwordTitle: 'Пароль только для чтения',
      passwordOnce: 'Этот пароль показывается ТОЛЬКО один раз: скопируйте его сейчас. Он нигде не сохраняется и не может быть прочитан снова — если вы его потеряете, предоставьте заново.',
      passwordUser: 'Пользователь',
      passwordLabel: 'Пароль',
      passwordHint: 'Действителен до {until} или до следующей перезагрузки узла; пригоден к использованию, когда задача предоставления завершена. Доступ: ssh trantor@<адрес узла>.',
      emergencyTitle: 'Последний аварийный доступ (trantor-emergency)',
      lastLogin: '{time} через {via} с {from}',
      lastLoginNone: 'не наблюдалось',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'консоль',
        sudo: 'sudo',
        unknown: 'неизвестно'
      },
      emergencyHint: 'Аварийная учётная запись «trantor-emergency» (полный sudo) всегда включена с паролем, сгенерированным при установке узла и хранящимся в сейфе: TVirt его не знает, не ротирует и не восстанавливает. Каждый вход сообщается здесь и в журнале событий.'
    },
    nodeFirewall: {
      tab: 'Брандмауэр',
      title: 'Брандмауэр узлов',
      subtitle: 'Режим ruleset nftables, который каждый узел применяет к самому себе — единственный брандмауэр узла (firewalld отключён)',
      modeLabel: 'Режим',
      mode: {
        disabled: 'Отключён — на узлах нет ruleset',
        permissive: 'Разрешающий — считает и записывает в журнал, ничего не отбрасывает',
        enforced: 'Принудительный — пропускается только производный реестр'
      },
      hint: {
        disabled: 'Как сегодня: узлы не несут никакого ruleset. Переключитесь в разрешающий режим, чтобы ПРОЧИТАТЬ, что было бы отброшено, прежде чем это будет отброшено.',
        permissive: 'Каждый узел применяет свой производный ruleset с policy accept: то, что отбросил бы принудительный режим, считается и записывается в журнал (префикс journal «tvirt-node would-drop:»). Ничего не блокируется.',
        enforced: 'Каждый узел применяет свой производный ruleset с policy drop: ssh и API отовсюду, store / live migration / overlay / Ceph только от членов, листенеры сетевых служб — из обслуживаемой сети. Каждое изменение — apply с подтверждением: узел, которому не удаётся подтвердить, откатывается сам.'
      },
      confirmTitle: 'Применить брандмауэр узлов?',
      confirmBody: 'Каждый узел применяет ruleset с подтверждением: через новые правила зондирует backend, store и ssh до истечения срока и подтверждает — иначе сам откатывается к предыдущему ruleset. Сначала прочитайте счётчики разрешающего режима на узлах.',
      confirmSubmit: 'Применить',
      confirmCancel: 'Отмена',
      lensTitle: 'Брандмауэр узла',
      loadError: 'Не удалось загрузить линзу брандмауэра узла',
      noReport: 'Отчёта брандмауэра от этого узла пока нет — воркер сообщит на следующем проходе',
      firewalldActive: 'На этом узле работает firewalld: брандмауэр узла отказывается применяться рядом с ним (замаскируйте firewalld)',
      conditionUnconfirmed: 'Подтверждённого ruleset пока нет — узел открыт',
      conditionRolledBack: 'Последний apply откатился — то же поколение не повторяется, пока реестр не изменится или режим не переключат снова',
      lastError: 'Последняя ошибка',
      posture: 'Режим',
      observedAt: 'Наблюдалось',
      desiredGeneration: 'Желаемое поколение',
      componentTitle: 'Компонент узла',
      componentSubtitle: 'tvirt-node-firewall — при загрузке применяет подтверждённый ruleset, неподтверждённый откатывает сам',
      componentAbsent: 'Компонент ещё не отчитался',
      phase: 'Фаза',
      phases: {
        none: 'Никогда не применялся',
        applied: 'Применён — ожидает подтверждения',
        confirmed: 'Подтверждён',
        rolledBack: 'Откачен'
      },
      generation: 'Поколение',
      appliedAt: 'Применено',
      confirmedAt: 'Подтверждено',
      deadline: 'Срок отката',
      lastRollback: 'Последний откат',
      registryTitle: 'Производный реестр',
      registrySubtitle: 'Порты, которые открывает этот узел, по классу и происхождению — выведены из кластера, никогда не правятся вручную',
      registryEmpty: 'Ничего не выведено — режим отключён без подтверждённого ruleset, либо отчёта ещё нет',
      colClass: 'Класс',
      colPort: 'Порт',
      colSource: 'Источник',
      colOrigin: 'Происхождение',
      classes: {
        public: 'Публичный',
        internode: 'Межузловой',
        tenant: 'Тенант'
      },
      sourceMembers: 'только члены',
      sourceAnywhere: 'отовсюду',
      sourceBridge: 'на {iface}'
    },
    derivationDerived: 'производный',
    derivationDiverged: 'разошедшийся',
    derivationDerivedTip: 'Сетевой документ ПРОИЗВЕДЁН от fabric {fabric} и всё ещё совпадает с рендером на текущих входах — клик для плана деривации.',
    derivationDivergedTip: 'Деривация от fabric {fabric} изменилась после последнего apply (fabric, кабельная разводка, роли или ссылки) — клик для ожидающего diff.',
    derivationRetiring: {
      one: '{n} адрес осушается',
      few: '{n} адреса осушаются',
      many: '{n} адресов осушаются',
      other: '{n} адреса осушается'
    },
    standaloneHint: 'У этого узла нет кластера: он еще не установлен. Кластеры создаются ИЛИ к ним присоединяются на этапе установки — токен, выпущенный из таблицы «Серверы» одного из членов, скармливается установщику (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Ваши права охватывают scope, а не весь кластер: инвентарь парка — узлы, настройки и устройства — виден только администраторам кластера.',
    phaseReady: 'Готов',
    phaseForming: 'Формируется',
    storeMembers: 'Члены хранилища конфигурации',
    watermark: 'Порог сходимости',
    configGeneration: 'Поколение конфигурации',
    converged: 'согласовано',
    behind: 'отстает — {m} / {n}',
    revision: 'Ревизия',
    rolesTitle: 'Сетевые роли',
    rolesSubtitle: 'Адреса каждого члена для каждого класса трафика — сама связность живет в сети хоста',
    roleManagement: 'Управление',
    roleLiveMigration: 'Живая миграция',
    roleInherited: 'наследует адреса управления',
    settingsTitle: 'Настройки',
    settingsSubtitle: 'Политика безопасности уровня кластера — каждый узел применяет ее по своей локальной реплике',
    taskRetentionTitle: 'Хранение задач',
    taskRetentionSubtitle: 'Единая сборка мусора для всех задач — завершенные задачи старше предельного возраста или сверх лимита убираются, выполняемые — никогда',
    taskRetentionMaxAge: 'Предельный возраст (дни)',
    taskRetentionMaxCount: 'Предельное число задач',
    eventRetentionTitle: 'Хранение событий',
    eventRetentionSubtitle: 'GC журнала — политика, независимая от политики задач: задача — это очередь, событие — это память',
    eventRetentionMaxAge: 'Максимальный возраст (дни)',
    eventRetentionMaxCount: 'Максимум хранимых событий',
    spaceThresholdsTitle: 'Пороги места',
    spaceThresholdsSubtitle: 'Когда заполняющееся хранилище попадает в журнал (и в уведомления)',
    spaceLowPct: 'Предупреждение от (% занято)',
    spaceCriticalPct: 'Критично от (% занято)',
    spaceOrderError: 'Критичный порог не может быть ниже предупреждения',
    spaceThresholdsHint: 'Настраиваются только входы: выход выводит движок, на 5 пунктов ниже каждого порога, чтобы хранилище на границе никогда не превратилось в метроном',
    failoverReserveTitle: 'Резерв отказоустойчивости',
    failoverReserveSubtitle: 'Контроль допуска N+1 — RAM, оставленная свободной, чтобы кластер мог перезапустить свою нагрузку после потери узлов',
    failoverReserveTolerate: 'Сколько потерянных узлов выдерживать',
    failoverReserveOff: '0 — резерв выключен: ни один запуск никогда не отклоняется из-за емкости отказоустойчивости',
    failoverReserveOn: 'Запуск, который съел бы резерв, отклоняется ответом 412 с разъяснением цифр',
    networkShapingTitle: 'Справедливость полосы',
    networkShapingSubtitle: 'Три типологических веса дерева shaping на каждый uplink — действуют только при конкуренции',
    networkShapingRest: 'Вес остального (плоскость управления, storage, реплики)',
    networkShapingOverlay: 'Вес overlay-сетей',
    networkShapingLiveMigration: 'Вес live migration',
    networkShapingHint: 'Гарантированная доля = вес / сумма трёх (по умолчанию 300 / 100 / 200, каждый от 1 до 10000); на свободном линке любой класс может занять всю полосу',
    debugModeTitle: 'Debug-режим',
    debugModeSubtitle:
      'Подробные ошибки в общих оповещениях GUI — чтобы увидеть истинную причину, когда действие, помеченное как «неудачное», на самом деле завершилось успешно',
    debugModeLabel: 'Debug-режим включен',
    debugModeOn: 'Общие оповещения об ошибках дописывают исходную причину — внутренние детали видны каждому оператору',
    debugModeOffHint: 'Выключен — общие оповещения об ошибках остаются общими, без внутренних деталей',
    nodeDetailsAction: 'Детали узла',
    node: {
      docTitle: 'Узел',
      notFound: 'Узел не найден',
      tabOverview: 'Обзор',
      tabStats: 'Статистика',
      tabNetwork: 'Сеть',
      tabSettings: 'Локальные настройки',
      identityTitle: 'Идентичность',
      heartbeatTitle: 'Пульс',
      ysqlPort: 'Порт YSQL',
      revision: 'Ревизия конфигурации',
      versionsTitle: 'Наблюдаемые версии',
      heartbeatSubtitle: 'Последнее состояние, о котором узел сообщил сам',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Модель CPU',
      memoryTitle: 'Память',
      hugePagesTitle: 'Огромные страницы',
      hugePagesPool: '{size}: {free} свободно из {total}',
      hugePagesNone: 'Пула нет',
      hugePagesNoneHint: 'На узле нет зарезервированных огромных страниц: ВМ, которые их просят, здесь не запустятся. Пул объявляется на узле параметрами ядра hugepagesz и hugepages либо записью в nr_hugepages.',
      usageTitle: 'Текущее использование',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'не наблюдается — свежих замеров нет',
      statsNoData: 'Нет данных за выбранный интервал — ряды узла снимаются самим узлом и отдаются локально.',
      observedTitle: 'Наблюдаемое состояние',
      observedSubtitle: 'Службы и локальные ресурсы узла, какими их видит воркер'
    },
    editRolesTitle: 'Изменить сетевые роли',
    memberNode: 'Узел',
    memberIp: 'IP-адрес',
    addMember: 'Добавить члена',
    lmInherit: 'Использовать адреса управления',
    roleIpHint: 'Добавлять и убирать членов можно свободно; смена IP существующего члена на месте отклоняется — процедура миграции IP появится в одном из следующих раундов.',
    roleError: 'Не удалось обновить роли',
    nodesTitle: 'Узлы',
    addNodeTitle: 'Добавить узел в кластер',
    addNode: 'Добавить узел',
    addNodeError: 'Не удалось предварительно зарегистрировать узел',
    nodeName: 'Имя узла',
    nodeNameHint: 'должно совпадать с именем, выбранным при установке',
    nodeIp: 'IP управления',
    colName: 'Имя',
    colPhase: 'Фаза',
    colServices: 'Службы',
    colWatermark: 'Порог',
    colLastSeen: 'Последний контакт',
    colUps: 'ИБП',
    upsCordonChip: 'кордон ИБП',
    upsCordonTip: 'Узел осудил себя по фактам своего ИБП ({time}): он сам снимет кордон, когда сеть станет стабильной, а батарея зарядится',
    upsUnreachable: 'ИБП недоступен',
    upsOnBattery: 'От батареи',
    upsOnLine: 'От сети',
    upsLowBattery: 'низкий заряд',
    upsNoEstimateChip: 'автономность не оценена',
    upsNoEstimateTip: 'ИБП не публикует оценку автономности: узел осуждается только флагом LB (низкий заряд) ИБП — настройте battery.runtime.low / LB на самом ИБП',
    upsLaneTip: 'Путь выключения по ИБП с {since}: осуждён по {by}',
    upsUnit: 'устройство',
    upsStatus: 'состояние NUT',
    upsLoad: 'нагрузка',
    upsOnBatterySince: 'от батареи с',
    upsOnLineSince: 'от сети с',
    upsError: 'ошибка',
    upsObservedAt: 'наблюдалось',
    upsNone: 'ни одно устройство ИБП не обслуживает этот узел',
    upsBy: {
      runtime: 'автономность ниже порога',
      lowBattery: 'флаг LB ИБП',
    },
    upsLane: {
      evacuate: 'эвакуация',
      local: 'выключение на месте',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'остановка гостей',
      stoppingServices: 'остановка служб',
      poweredOff: 'выключен',
    },
    upsTitle: 'ИБП (NUT)',
    upsSubtitle: 'Устройства ИБП и пороги: узел осуждается при автономности ≤ порога или по флагу LB (всегда учитывается), возобновление с гистерезисом',
    upsRuntimeThreshold: 'Порог автономности (с)',
    upsRuntimeThresholdHint: 'От батареи при оценённой автономности ≤ порога узел выключается по порядку (по умолчанию 300)',
    upsResumeStable: 'Сеть стабильна в течение (с)',
    upsResumeStableHint: 'Возобновление только при непрерывной сети не менее стольких секунд (по умолчанию 60)',
    upsResumeCharge: 'Минимальный заряд при возобновлении (%)',
    upsResumeChargeHint: 'И батарея заряжена не менее чем до этого процента (по умолчанию 25)',
    upsPolicyNote: 'Флаг LB (низкий заряд) ИБП осуждает всегда и не отключается; порога на время работы от батареи нет. Каждое устройство может переопределить три числа.',
    upsUnitNew: 'новое устройство',
    upsUnitSelectors: '{n} селектор(ов) по тегам (только CLI)',
    upsUnitName: 'Имя устройства',
    upsUnitMode: 'Режим',
    upsModeExternal: 'внешнее (чужой upsd)',
    upsModeManaged: 'управляемое (ИБП подключён к узлу)',
    upsUnitUpsname: 'Имя NUT (upsname)',
    upsUnitHost: 'Хост upsd',
    upsUnitAttachedNode: 'Подключённый узел',
    upsUnitDriver: 'Драйвер NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Устройство драйвера',
    upsUnitDeviceHint: 'строка port= в ups.conf: пусто = auto',
    upsUnitPort: 'Порт upsd',
    upsUnitServedNodes: 'Обслуживаемые узлы',
    upsUnitServedNodesHint: 'имена узлов через запятую (селекторы по тегам — через CLI)',
    upsUnitOverrideHint: 'пусто = значение кластера',
    upsUnitAdd: 'Добавить устройство',
    unreachableSince: 'Недоступен — последний сигнал пульса {time}',
    overlaysChip: 'оверлей',
    overlaysBehind: 'Плоскость данных оверлея еще не воплотила текущую конфигурацию оверлея',
    overlaysError: 'Последний проход согласования оверлея завершился ошибкой: {error}',
    storeChip: 'хранилище конфигурации',
    phase: {
      'pending-join': 'Ожидает присоединения',
      'joining': 'Присоединяется',
      'member': 'Член'
    },
    tokenTitle: 'Токен присоединения',
    tokenOnce: 'Показывается только сейчас — скопируйте его немедленно, прочитать снова будет нельзя',
    copy: 'Копировать',
    copied: 'Скопировано',
    close: 'Закрыть',
    revokeTitle: 'Отзыв предварительной регистрации',
    revoke: 'Отозвать',
    revokeError: 'Не удалось отозвать регистрацию',
    promote: 'Повысить до члена хранилища конфигурации',
    demote: 'Убрать роль члена хранилища конфигурации',
    troubleshoot: 'Устранение неполадок',
    promoteTitle: 'Повышение до члена хранилища конфигурации',
    demoteTitle: 'Снятие роли члена хранилища конфигурации',
    promoteHint: 'Узел входит в кворум мастеров YugabyteDB. Настоящая HA требует трех членов хранилища конфигурации.',
    demoteHint: 'Узел выходит из кворума мастеров и останавливает свои службы хранилища конфигурации.',
    storeError: 'Изменение членства в хранилище конфигурации отклонено',
    attest: 'Подтвердить выключение…',
    attestTitle: 'Подтверждение выключения узла',
    attestSubmit: 'Подтвердить выключение',
    attestConfirm: 'Вы заявляете, что этот узел выключен, под свою ответственность: подтверждать выключение на самом деле живого узла — рисковать двойным запуском ВМ. Его задачи будут помечены как неудачные, а полномочия его ВМ станут передаваемыми.',
    attestError: 'Подтверждение отклонено',
    attestedChip: 'выключение подтверждено',
    maintenanceChip: 'обслуживание',
    guestToolsChip: 'TVirt Guest Tools (локальный ресурс ISO на узле)',
    maintenanceEnter: 'Включить обслуживание',
    maintenanceExit: 'Выключить обслуживание',
    maintenanceEnterTitle: 'Включить обслуживание',
    maintenanceExitTitle: 'Выключить обслуживание',
    maintenanceEnterSubmit: 'Включить обслуживание',
    maintenanceExitSubmit: 'Выключить обслуживание',
    maintenanceEnterConfirm: 'Узел изолируется и освобождается: сетевые службы и экземпляры App, authority которых он держит, переносятся (экземпляры холодно: остановлены и убраны здесь, пересозданы на целевом узле — простой), работающие VM мигрируют вживую, где возможно, иначе корректно останавливаются, текущие задачи завершаются, новая работа ждёт, а остановленные VM теряют свою authority — Proximity размещает их заново при следующем запуске. По окончании обслуживания ничто не возвращается само.',
    maintenanceExitConfirm: 'Узел снова принимается за работу, и Proximity опять учитывает его при размещении. ВМ возвращаются, только когда их запускают.',
    maintenanceError: 'Запрос на обслуживание отклонен',
    maintenancePlanTitle: 'План эвакуации',
    maintenancePlanLoading: 'Расчет плана эвакуации…',
    maintenancePlanError: 'Не удалось загрузить план эвакуации — освобождение узла все равно перенесет то, что сможет, и остановит остальное.',
    maintenancePlanEmpty: 'На этом узле нечего эвакуировать — нет активной сетевой службы, нет экземпляра App, требуемого в работе, нет работающей VM.',
    maintenancePlanSummary: '{migrate} объектов будут перенесены (VM, сетевые службы, экземпляры App), {stop} остановятся или останутся на месте.',
    maintenancePlanReserve_ok: 'Резерв отказоустойчивости после освобождения: в норме — остается {headroom} GiB, пригодных для запуска, с запасом на потерю узлов: {n}.',
    maintenancePlanReserve_eroded: 'Резерв отказоустойчивости после освобождения: почти израсходован — остается лишь {headroom} GiB из {reserve} GiB, которые держатся свободными на случай отказа узлов: {n}.',
    maintenancePlanReserve_exhausted: 'Резерв отказоустойчивости после освобождения: ИСЧЕРПАН — не хватает {headroom} GiB из {reserve} GiB, необходимых, чтобы выдержать отказ узлов: {n}. Пока этот узел выведен, новые запуски ВМ будут отклоняться.',
    maintenancePlanReserve_unknown: 'Резерв отказоустойчивости после освобождения: рассчитать нельзя — ни один из оставшихся узлов не заявил объем памяти.',
    maintenancePlanReserveHugePages: 'Огромные страницы по {size} после освобождения — свободно: {free} из {capacity}, требуется в резерве: {reserve}.',
    maintenancePlanActionMigrate: 'переносится',
    maintenancePlanActionMigrateWarning: 'переносится (мягкое правило нарушено)',
    maintenancePlanActionStop: 'останавливается',
    maintenancePlanActionBlocked: 'заблокирована',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'сетевая служба',
    maintenancePlanKindApp: 'экземпляр App',
    maintenancePlanColdMove: 'Холодный перенос: под останавливается и убирается здесь, а worker целевого узла пересоздаёт его — простой до следующего pass целевого worker.',
    caFingerprint: 'Отпечаток CA кластера',
    staleChip: 'устарело',
    troubleshootTitle: 'Устранение неполадок хранилища конфигурации',
    restartStore: 'Перезапустить службы хранилища конфигурации',
    restartHint: 'Если хранилище конфигурации капризничает, перезапустите его службы. Для опытных — применять с осторожностью.',
    restartQueued: 'Задача перезапуска поставлена в очередь',
    restartError: 'Не удалось перезапустить службы',
    svcActive: 'активна',
    svcWanted: 'требуется, но не активна',
    svcStopped: 'остановлена',
    noServices: 'Ни об одной службе не сообщено'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Инвентарь GPU всего кластера с группировкой по моделям — карты, наблюдаемые на каждом узле, с отмеченными регистрациями и их тегами',
    usbTitle: 'Ресурсы USB',
    usbSubtitle: 'Инвентарь USB всего кластера с группировкой по моделям — устройства, наблюдаемые на каждом узле, с регистрациями обеих моделей (на устройство, на порт) и их тегами',
    markedChip: 'пригодных для TVirt: {n}',
    orphanChipGpu: 'осиротевших: {n}',
    orphanChipUsb: 'осиротевших: {n}',
    colNode: 'Узел',
    colRegistration: 'Регистрация',
    noRegsHint: 'Регистраций нет — устройство отмечается как «пригодное для TVirt» в диалоге узла (Узлы › узел › Настройки).',
    colDevice: 'Устройство',
    colObserved: 'Наблюдаемые',
    colRegs: 'Регистрации',
    regsNone: 'нет',
    colPci: 'Адрес PCIe',
    colIdentity: 'Идентичность / порт',
    colClasses: 'Классы (теги)',
    colActions: 'Действия',
    manageOnNode: 'Управляйте на узле {node} (отметка живет в диалоге узла)',
    introTitle: 'Кластерный инвентарь устройств USB и PCIe, пригодных для TVirt©.',
    introStep1: '1. Узлы сами обнаруживают свои GPU и устройства USB (перепись в сигнале пульса).',
    introStep2: '2. Устройство отмечается как «пригодное для TVirt» в диалоге УЗЛА (Узлы › узел › Настройки) — отметка привязывает его к vfio и регистрирует здесь.',
    introStep3: '3. Здесь вы даете регистрациям их КЛАССЫ через теги (например, gpu_class=compute): требования ВМ запросят класс, а планировщик выберет узел со свободным совместимым устройством.',
    colMode: 'Режим',
    colState: 'Состояние',
    colNotes: 'Заметки',
    colTags: 'Теги',
    modeDevice: 'на устройство',
    modePort: 'на порт',
    usable: 'пригодно',
    orphanGpu: 'осиротевшая',
    orphanUsb: 'осиротевшее',
    hubChip: 'хаб',
    orphanPortsTitle: 'Регистрации на порт без подключенного устройства — подключите устройство заново или снимите с них отметку на узле',
    gpusEmpty: 'Ни на одном узле еще не наблюдалось ни одной GPU',
    usbEmpty: 'Ни на одном узле еще не наблюдалось ни одного устройства USB'
  },

  // Общий словарь форм настроек (рефакторинг 2026-07-24): поля безопасности
  // питают карточку страницы «Кластер», поля узла — страницу node-settings;
  // страница /system/settings, ради которой они появились, мертва.
  settings: {
    passwordMinLength: 'Минимальная длина пароля',
    sessionIdle: 'Таймаут бездействия сеанса (минуты)',
    lockoutThreshold: 'Блокировка после неудачных попыток',
    lockoutDuration: 'Длительность блокировки (минуты)',
    keyboardLayout: 'Раскладка клавиатуры',
    keyboardLayoutHint: 'например, it, en-us — пусто для значения QEMU по умолчанию',
    syslogEndpoint: 'Конечная точка syslog',
    syslogEndpointHint: 'хост:порт — пусто, чтобы отключить пересылку',
    syslogTls: 'TLS',
    maxQueued: 'Предельное число задач в очереди',
    concurrency: 'Параллелизм воркера',
    concurrencyHint: 'Применяется воркером на лету',
    notesTitle: 'Заметки',
    save: 'Сохранить',
    saved: 'Настройки сохранены',
    saveError: 'Не удалось сохранить настройки'
  },
  localSettings: {
    derivedChip: 'производный',
    derivedTip: 'Этот device ПРИНАДЛЕЖИТ деривации fabric (H2): редактор отказывается его трогать — измените fabric (или разводку) и примените заново, или заберите его ниже.',
    takeOwnership: 'Взять во владение',
    takeOwnershipTitle: 'Взять во владение (take-ownership)',
    takeOwnershipConfirm: '{name} покидает блок fabric и снова становится РУЧНЫМ device, которым правит этот редактор. Узел становится разошедшимся, и следующий apply деривации откажет на нём (manualConflict), пока вы его не переименуете или не удалите — или не исправите fabric.',
    nodeSettingsTitle: 'Настройки узла',
    nodeSettingsSubtitle: 'То, что применяет этот узел — очередь задач, консоль, пересылка журналов — плюс его теги и заметки',
    baseTitle: 'Резервы хоста (TVirt Proximity)',
    baseSubtitle: 'CPU и RAM, зарезервированные под операционную систему хоста — исходные данные эмпирической емкости, по которой Proximity размещает ВМ',
    baseMemory: 'Базовая RAM (MiB)',
    baseMemoryHint: 'Наблюдаемый итог: {total} MiB. Доступно для ВМ = итог − база − RAM запущенных ВМ, размещенных здесь.',
    baseMemoryHintNoTotal: 'Доступно для ВМ = наблюдаемый итог − база − RAM запущенных ВМ, размещенных здесь.',
    baseCpu: 'Базовые ядра CPU',
    baseCpuHint: 'Наблюдаемых логических CPU: {total}. Используются только как вес при ранжировании — переподписка vCPU это норма.',
    baseCpuHintNoTotal: 'Используются только как вес при ранжировании — переподписка vCPU это норма.',
    baseHint: 'RAM — жесткий шлагбаум допуска: ВМ, которая не помещается в доступную RAM, отклоняется с внятной ошибкой. Поднимайте базу на хостах, где живут члены хранилища конфигурации или демоны Ceph.',
    placementTitle: 'Физическое размещение',
    placementSubtitle: 'Где физически стоит этот сервер — объявляется один раз, на все случаи',
    placementHint: 'Размещение задает иерархию CRUSH каждого кластера Ceph, у которого есть OSD на этом сервере: сохранение изменения перестраивает их карты через задачу (хост → стойка → … → корень). Частичные объявления допустимы — пустые уровни схлопываются. Имена общие для всей карты: два сервера в одной стойке объявляют одно и то же имя стойки.',
    placementNameInvalid: 'Безопасное для DNS имя (строчные буквы, цифры, дефисы)',
    placementEmpty: 'Пусто = не объявлено',
    placementLevel: {
      chassis: 'Шасси',
      rack: 'Стойка',
      row: 'Ряд',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Помещение',
      datacenter: 'Датацентр',
      zone: 'Зона',
      region: 'Регион'
    },
    cablingTitle: 'Кабельные подключения',
    cablingSubtitle: 'К какому порту коммутатора подключен каждый интерфейс — объявление живет на узле (Annex O.9)',
    cablingHint: 'Один кабель на NIC, один кабель на порт по всему парку (API отклоняет запрос, называя владельца). Подключать кабель к порту, входящему в LAGG, допустимо — это случай бонда: будущий вывод отобразит его как LACP.',
    cablingInterface: 'Интерфейс',
    cablingNotCabled: '— не подключен —',
    cablingNoInterfaces: 'Сетевых интерфейсов не наблюдается',
    disksTitle: 'Диски',
    disksSubtitle: 'Наблюдаемые блочные устройства — одно сканирование за проход согласования; отметьте здесь диски, пригодные как OSD Ceph (N.15: пригодность объявляется явно)',
    colDataDisk: 'Диск данных',
    dataDisksHint: 'Отметка устройства объявляет его пригодным как OSD; серийный номер — его якорь идентичности: он копируется из оборудования, когда диск его сообщает, и чеканится (tvirt-…) в остальных случаях. Диалог регистрации Ceph предлагает только объявленные диски.',
    diskDeclaredSerial: 'объявлено',
    diskNotObserved: 'объявлено, но не наблюдается — верните устройство на место или снимите отметку',
    noDisks: 'Блочных устройств пока не наблюдалось',
    colSerial: 'Серийный номер',
    colModel: 'Модель',
    colSize: 'Размер (GiB)',
    colDiskType: 'Тип',
    colInUse: 'Занят',
    colObservedAt: 'Наблюдалось',
    diskInUse: 'занят',
    diskFree: 'свободен',
    diskMounted: 'смонтирован',
    diskPartitions: 'разделы',
    passthroughTitle: 'Проброс устройств',
    passthroughSubtitle: 'Наблюдаемые GPU и устройства USB — отметьте здесь, что TVirt может пробрасывать в ВМ; отметка регистрирует идентичность устройства (раунды U1+G1)',
    passthroughHint: 'Отметка регистрирует устройство (стабильный идентификатор — цель для тегов и требований по классу). У отмеченной GPU ВСЯ группа IOMMU разом привязывается к vfio-pci — она сразу покидает хост; снятие отметки возвращает штатный драйвер. Для USB существуют обе утвержденные модели: на устройство (производитель+продукт, куда бы оно ни было воткнуто) и на физический порт (в ВМ попадает все, что в него вставлено). USB не привязывается при отметке — подключение происходит во время работы ВМ.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Пригодно для TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Адрес PCI',
    colDriver: 'Драйвер',
    colVerdict: 'Вердикт',
    gpuEligible: 'Подходит',
    gpuIneligible: 'Не подходит',
    gpuReason: {
      'no-iommu': 'IOMMU не включен на хосте',
      'group-spans-slots': 'группа IOMMU не изолирована: захватывает и другие слоты',
      'multiple-display': 'группа IOMMU не изолирована: более одной видеофункции',
      'foreign-function': 'группа IOMMU не изолирована: содержит постороннюю функцию'
    },
    vfioNotReady: 'IOMMU на этом хосте не включен: ни одна GPU не подойдет, пока платформа хоста его не включит (OEM ISO) — TVirt никогда не правит параметры ядра во время работы.',
    vfioMissingKernelArg: 'IOMMU на этом хосте не включен: прошивка сообщает о VT-d/AMD-Vi (таблица ACPI DMAR/IVRS присутствует), но не хватает параметра ядра — добавьте intel_iommu=on (Intel) или уберите amd_iommu=off (AMD) из командной строки ядра и перезагрузитесь. TVirt никогда не правит параметры ядра во время работы.',
    vfioFirmwareDisabled: 'IOMMU на этом хосте не включен: VT-d/AMD-Vi отключен в прошивке (таблиц ACPI DMAR/IVRS нет) либо CPU его не поддерживает — включите его в настройках прошивки, никакой параметр ядра этого не сделает. TVirt никогда не правит хост во время работы.',
    gpuBindError: 'Не удалось привязать vfio-pci на {address}: {error}',
    firewallBridgesTitle: 'Брандмауэр на неуправляемых бриджах',
    firewallBridgesSubtitle: 'Собранные вручную бриджи этого узла, чья настройка соглашается на цепочки брандмауэра, которые TVirt рендерит на подключенных гостевых NIC',
    firewallBridgesHint: 'TVirt никогда не трогает чужой бридж — цепочка крепится на tap/veth, который всегда принадлежит TVirt. Список — это ворота согласия: default-deny и антиспуфинг могут сломать то, чего ждет ручная настройка, поэтому гостевая NIC с брандмауэром на неуправляемом бридже, НЕ перечисленном здесь, отклоняется с внятной ошибкой.',
    firewallBridgesEmpty: 'Ни один неуправляемый бридж не соглашается на цепочки брандмауэра, которые TVirt рендерит на этом узле.',
    firewallBridgeAdd: 'Добавить бридж',
    firewallBridgeInvalid: 'Не имя интерфейса Linux (1-15 символов, без слеша и пробелов)',
    firewallBridgeDuplicate: 'Имя уже в списке',
    colMarkDevice: 'На устройство',
    colMarkPort: 'На порт',
    usbHub: 'хаб',
    colUsbId: 'Vendor:Product',
    colPort: 'Порт',
    passthroughOrphan: 'осиротело — зарегистрировано, но больше не обнаруживается: подключите заново или снимите отметку',
    noGpus: 'GPU пока не наблюдались',
    noUsb: 'Устройств USB пока не наблюдалось',
    networkGeneration: 'Поколение сети',
    applied: 'Применено',
    converged: 'согласовано',
    behind: 'отстает — {m} / {n}',
    notConfigured: 'не настроено',
    rollbackBody: 'Не удалось применить поколение {gen}: {error}',
    rolledBackChip: 'откат выполнен',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Реестр управляемых NIC — регистрация И ЕСТЬ объявление об управлении: зарегистрированная NIC без конфигурации не трогается (clear-if объявляет ее явно чистой), а незарегистрированное устройство не трогается никогда',
    addNic: 'Зарегистрировать NIC',
    addNicTitle: 'Зарегистрировать NIC (add-nic)',
    delNic: 'Прекратить управление',
    delNicTitle: 'Прекратить управление (del-nic)',
    delNicConfirm:
      'Управление {name} прекращается: запись реестра и ее конфигурация удаляются, а профиль TVirt снимается — устройство остается таким, каким его держит Linux.',
    nicName: 'Имя устройства',
    nicMac: 'Постоянный MAC-адрес',
    nicMacHint: 'постоянный аппаратный MAC — стабильная идентичность, зафиксированная программой TVirt Server Installer',
    colObserved: 'Наблюдается',
    nicObserved: 'наблюдается',
    nicNotObserved: 'не наблюдается',
    nicMacMismatch: 'MAC расходится — наблюдается {mac}',
    noNics: 'Зарегистрированных NIC нет — зарегистрируйте устройство, чтобы начать им управлять',
    noManagedDevices: 'Управляемых устройств нет — сначала зарегистрируйте NIC, все строится на реестре',
    inventoryTitle: 'Наблюдаемые устройства',
    inventorySubtitle: 'Обновляются на каждом проходе согласования воркером узла — проверка сверяет имена устройств с этим инвентарем',
    colDevice: 'Устройство',
    colType: 'Тип',
    colMac: 'MAC',
    colLink: 'Линк',
    colSpeed: 'Скорость',
    colTopology: 'Топология',
    colMtu: 'MTU',
    colAddresses: 'Адреса',
    linkUp: 'поднят',
    linkDown: 'опущен',
    lacpDegraded: 'LACP не агрегирует',
    noInventory: 'Ни об одном устройстве пока не сообщено',
    interfacesTitle: 'Интерфейсы',
    interfacesSubtitle:
      'Конфигурация L3 зарегистрированных NIC и объявленных логических устройств — set-if заменяет блок целиком, edit-if правит свойства, clear-if его опустошает (явная очистка)',
    colConfig: 'Желаемая конфигурация',
    clean: 'чистая',
    setIf: 'Изменить адресацию',
    setIfTitle: 'Изменить адресацию (set-if)',
    editIf: 'Изменить свойства',
    editIfTitle: 'Изменить свойства (edit-if)',
    clearIf: 'Очистить конфигурацию',
    clearIfTitle: 'Очистить конфигурацию (clear-if)',
    clearIfConfirm: 'Конфигурация интерфейса очищается. Чистый интерфейс — обязательное условие, чтобы подчинить его как участника бонда или бриджа либо как родителя VLAN.',
    ip4Mode: 'Режим IPv4',
    ip6Mode: 'Режим IPv6',
    modeUnconfigured: 'Не настроен',
    modeStatic: 'Статический',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Адреса IPv4',
    ip6Addresses: 'Адреса IPv6',
    addressesHint: 'CIDR, через запятую',
    gw4: 'Шлюз IPv4',
    gw6: 'Шлюз IPv6',
    dns: 'Серверы DNS',
    dnsHint: 'через запятую — пусто обнуляет DNS (set-if заменяет блок)',
    routes4: 'Статические маршруты IPv4',
    routes6: 'Статические маршруты IPv6',
    routeTo: 'Назначение (CIDR)',
    routeVia: 'Через',
    addRoute: 'Добавить маршрут',
    routesChip: 'маршруты',
    mtu: 'MTU',
    mtuHint: 'пусто = значение драйвера по умолчанию',
    vlansTitle: 'VLAN',
    addVlan: 'Добавить VLAN',
    addVlanTitle: 'Добавить VLAN (add-vlan)',
    delVlanTitle: 'Удалить VLAN (del-vlan)',
    vlanParent: 'Родительский интерфейс',
    vlanId: 'ID VLAN',
    vlanPreview: 'Имя устройства',
    colParent: 'Родитель',
    colVlanId: 'ID',
    noVlans: 'Ни одной VLAN не объявлено',
    bondsTitle: 'Бонды',
    addBond: 'Добавить бонд',
    addBondTitle: 'Добавить бонд (add-bond)',
    editBondTitle: 'Изменить бонд',
    editBond: 'Сохранить бонд',
    delBondTitle: 'Удалить бонд (del-bond)',
    bondName: 'Имя бонда',
    members: 'Участники',
    membersHint: 'участниками могут быть только чистые интерфейсы (без конфигурации L3)',
    bondMode: 'Режим',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (мс)',
    primary: 'Основной участник',
    rate: 'Частота LACP',
    hash: 'Политика хеширования при передаче',
    colMembers: 'Участники',
    colMode: 'Режим',
    noBonds: 'Ни одного бонда не объявлено',
    bridgesTitle: 'Бриджи',
    addBridge: 'Добавить бридж',
    addBridgeTitle: 'Добавить бридж (add-bridge)',
    editBridgeTitle: 'Изменить бридж',
    editBridge: 'Сохранить бридж',
    delBridgeTitle: 'Удалить бридж (del-bridge)',
    bridgeName: 'Имя бриджа',
    stp: 'STP',
    stpOn: 'STP включен',
    stpOff: 'STP выключен',
    colStp: 'STP',
    noBridges: 'Ни одного бриджа не объявлено',
    hostnameTitle: 'Имя хоста',
    hostname: 'Имя хоста',
    setHostname: 'Задать имя хоста',
    setHostnameTitle: 'Задать имя хоста (set-hostname)',
    hostnameHint: 'Только идентичность ОС — имя узла в кластере не затрагивается',
    notSet: 'не задано',
    staticHostsTitle: 'Статические записи хостов',
    addStaticHost: 'Добавить запись',
    addStaticHostTitle: 'Добавить статическую запись хоста',
    delStaticHostTitle: 'Удалить статическую запись хоста',
    hostIp: 'IP-адрес',
    hostNames: 'Имена',
    hostNamesHint: 'через запятую или пробел',
    colIp: 'IP',
    colNames: 'Имена',
    noStaticHosts: 'Статических записей хостов нет',
    delConfirm: '{name} убирается из желаемого документа — воркер узла сходится с контрольной точкой NetworkManager и автоматическим откатом.',
    remove: 'Убрать',
    opError: 'Сетевая операция отклонена'
  }
}
